import { render, staticRenderFns } from "./AdminManageDatasetsPage.vue?vue&type=template&id=980dd510"
import script from "./AdminManageDatasetsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminManageDatasetsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports